import React from "react";
import styled from "styled-components";

export default styled.div`
    top: 42px;
    position: relative;
    font-size: 13px;
    width: 80px;
    display: block;
    text-align: center;
    color: #6A6D90;

    ${(props) => (props.layout ? {
    'top': '50%',
    'transform': 'translateY(-50%)'
} : '')}

    ${(props) => (props.open ? {
    'color': 'white'
} : '')}
`;